import About from "./about/About";
import ContactSection from "./contact/Contact";
import Features from "./features/Features";
import Hero from "./hero/hero"
import HomeProducts from "./products/Products";
import 'aos/dist/aos.css';

import AOS from 'aos';
import { useEffect } from "react";

const Home = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <>
            <Hero />
            <About />
            <HomeProducts />
            <Features />
            <ContactSection />
            {/*
            <Training />
            <Coworking />
            <Consulting /> */}
        </>

    )
}

export default Home;